module.exports = __webpack_public_path__ + "img/bell-dot.c925f389.svg";